<template>
  <div>
    <Header>
      <template v-slot:title>
        {{ $t("request-a-payment") }}
      </template>
    </Header>
    <div
      v-if="get_ib_profile.state === 'Approved'"
      class="bg-white shadow rounded-md min-h-screen max-w-3xl m-auto sm:mt-5"
    >
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(requestPayment)">
          <div>
            <div>
              <h3 class="py-5 text-lg leading-6 font-medium text-gray-900">
                {{ $t("request-a-payment") }}
              </h3>
              <p class="text-gray-700 text-sm py-5">
                {{
                  $t(
                    "you-will-be-notified-via-email-when-your-request-is-processed"
                  )
                }}

                <span
                  v-html="
                    sanitizeText(
                      $t(
                        'please-enter-the-amount-you-wish-to-withdraw-please-note-that-pending-requestswill-be-deducted-from-'
                      )
                    )
                  "
                ></span>
              </p>
            </div>
          </div>
          <div class="border-t border-gray-200">
            <div class="flex flex-col">
              <div>
                <div
                  v-if="get_profile.profile"
                  class="align-middle inline-block min-w-full"
                >
                  <div class="mt-8 sm:mt-0 sm:border-gray-200 sm:py-5"></div>
                  <div class="border-b border-gray-200">
                    <div
                      class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:border-gray-200 sm:py-5"
                    >
                      <dt class="text-sm leading-5 font-normal sm:col-span-3">
                        {{ $t("total-earned") }}
                      </dt>
                      <dd
                        class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                      >
                        <div class="sm:col-span-2">
                          <money-format
                            :currency-code="get_profile.profile.currency"
                            :value="get_payments_info.total_earned"
                          >
                          </money-format>
                        </div>
                      </dd>
                    </div>
                  </div>
                  <div class="border-b border-gray-200">
                    <div
                      class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:border-gray-200 sm:py-5"
                    >
                      <dt class="text-sm leading-5 font-normal sm:col-span-3">
                        {{ $t("total-paid-to-date") }}
                      </dt>
                      <dd
                        class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                      >
                        <div class="sm:col-span-2">
                          <money-format
                            :currency-code="get_profile.profile.currency"
                            :value="get_payments_info.total_withdrawn"
                          >
                          </money-format>
                        </div>
                      </dd>
                    </div>
                  </div>
                  <div class="border-b border-gray-200">
                    <div
                      class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:border-gray-200 sm:py-5"
                    >
                      <dt class="text-sm leading-5 font-normal sm:col-span-3">
                        {{ $t("Balance") }}
                      </dt>
                      <dd
                        class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                      >
                        <div class="sm:col-span-2">
                          <money-format
                            :currency-code="get_profile.profile.currency"
                            :value="get_payments_info.balance"
                          >
                          </money-format>
                        </div>
                      </dd>
                    </div>
                  </div>
                  <div class="border-b border-gray-200">
                    <div
                      class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:border-gray-200 sm:py-5"
                    >
                      <dt class="text-sm leading-5 font-normal sm:col-span-3">
                        {{ $t("withdrawable-amount") }}
                      </dt>
                      <dd
                        class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                      >
                        <div class="sm:col-span-2">
                          <money-format
                            :currency-code="get_profile.profile.currency"
                            :value="get_payments_info.withdrawable_balance"
                          >
                          </money-format>
                        </div>
                      </dd>
                    </div>
                  </div>
                  <div
                    v-if="
                      whitelabel !== 'TD365' &&
                      whitelabel !== 'TDSouthAfrica' &&
                      whitelabel !== 'Blackstone' &&
                      whitelabel !== 'OneTradingMarkets' &&
                      whitelabel !== 'EagleGlobalMarkets' &&
                      whitelabel !== 'TradeCoreUK'
                    "
                  >
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="method"
                      rules="required"
                    >
                      <div
                        class="mt-8 sm:mt-0 sm:border-gray-200 sm:py-5 sm:grid sm:grid-cols-6 sm:gap-4"
                      >
                        <dt
                          class="text-sm leading-5 font-normal mb-3 sm:col-span-3"
                        >
                          {{ $t("Choose-a-payment-method") }}
                        </dt>
                        <dd
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3"
                        >
                          <div>
                            <v-select
                              v-model="form.selectedMethod"
                              :options="get_ib_withdrawal_methods"
                              :placeholder="
                                $t(
                                  'select-an-option-59d5d61e9e9b2dc33a0211623cc4fe11'
                                )
                              "
                              label="display_name"
                              @input="updateSelectedGateway"
                            ></v-select>
                          </div>
                          <span class="text-sm text-red-600 h-4">{{
                            errors[0]
                          }}</span>
                        </dd>
                      </div>
                    </ValidationProvider>
                  </div>

                  <div>
                    <div
                      v-if="
                        whitelabel !== 'TD365' &&
                        whitelabel !== 'TDSouthAfrica' &&
                        whitelabel !== 'Blackstone' &&
                        whitelabel !== 'OneTradingMarkets' &&
                        whitelabel !== 'EagleGlobalMarkets' &&
                        whitelabel !== 'TradeCoreUK'
                      "
                    >
                      <div class="mt-8 sm:mt-0 sm:border-gray-200 sm:py-5">
                        <dt class="text-sm leading-5 font-normal mb-3">
                          {{
                            $t("choose-a-payment-gateway-for-selected-method")
                          }}
                        </dt>
                        <dd
                          v-if="form.selectedMethod"
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0"
                        >
                          <div class="grid grid-cols-3 gap-6">
                            <div
                              v-for="(gateway, index) in form.selectedMethod
                                .gateways"
                              :key="index"
                              :class="
                                form.selectedGateway.id === gateway.id
                                  ? 'border-blue'
                                  : ''
                              "
                              class="border-gray-200 border cursor-pointer rounded-md max-w-xs-gateway sm:col-span-1"
                              @click="setGateway(gateway)"
                            >
                              <img
                                :src="
                                  require(`../../../assets/gateways/${
                                    gateway.name
                                  }${
                                    gateway.name === 'praxispay' ||
                                    gateway.name === 'bridgerpay' ||
                                    gateway.name === 'vaultspay'
                                      ? '.png'
                                      : '.svg'
                                  }`)
                                "
                                alt=""
                                class="m-auto h-16"
                              />
                              <div
                                class="text-xs text-gray-400 p-1 bottom-0 font-light border-t flex"
                              >
                                <span class="mr-2">
                                  {{ $t("via") }}
                                </span>
                                <span
                                  v-if="gateway.name === 'safecharge'"
                                  class="my-auto"
                                >
                                </span>
                                <span
                                  v-if="gateway.name === 'worldpay'"
                                  class="my-auto"
                                >
                                  <svg
                                    fill="none"
                                    height="16"
                                    viewBox="0 0 82 16"
                                    width="82"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M23.0376 12.1669L21.4778 5.78067L19.6977 12.1669H17.9177L15.6421 5.19343C15.5687 4.99157 15.4953 4.97322 15.3118 4.91817L14.6328 4.77136L14.8347 3.8905H18.0828V4.77136L17.0552 4.89981L18.8536 10.6804L20.707 4.11072H22.3953L23.9552 10.6621L25.7536 4.89981L24.7076 4.77136L24.8911 3.8905H27.9374V4.77136L27.3501 4.86311C27.0749 4.91817 27.0198 4.97322 26.9464 5.19343L24.7626 12.1669H23.0376Z"
                                      fill="#9D9D9C"
                                    />
                                    <path
                                      d="M34.3241 8.00115C34.3241 5.89077 33.5534 4.95487 31.9935 4.95487C30.4153 4.95487 29.4978 5.89077 29.4978 8.0195C29.4978 10.1666 30.3236 11.1942 31.9201 11.1942C33.4799 11.1942 34.3241 10.2033 34.3241 8.00115ZM27.9746 8.00115C27.9746 5.4687 29.2592 3.72534 32.0119 3.72534C34.7645 3.72534 35.8289 5.48705 35.8289 7.89105C35.8289 10.607 34.5994 12.3504 31.8467 12.3504C29.0573 12.3687 27.9746 10.552 27.9746 8.00115Z"
                                      fill="#9D9D9C"
                                    />
                                    <path
                                      d="M36.599 12.1669V11.286L37.4064 11.1942C37.6267 11.1575 37.6634 11.1208 37.6634 10.8639V5.37694C37.6634 5.19343 37.6083 5.08332 37.4615 5.04662L36.5439 4.73465L36.6908 3.87215H38.8011L38.9663 4.99157L39.0213 5.00992C39.5535 4.40433 40.3426 3.72534 41.4437 3.72534C41.8107 3.72534 42.3062 3.79875 42.5998 3.87215V6.31285L41.462 6.2578L41.2602 5.13838C41.2418 5.00992 41.2051 4.97322 41.0583 4.97322C40.3243 4.97322 39.5168 5.63386 39.1315 5.98253V10.8272C39.1315 11.0841 39.1498 11.1392 39.3884 11.1575L40.8748 11.286V12.1485H36.599V12.1669Z"
                                      fill="#9D9D9C"
                                    />
                                    <path
                                      d="M43.0586 12.1668V11.2859L44.0496 11.1942C44.2698 11.1758 44.3065 11.1208 44.3065 10.8639V1.50479C44.3065 1.32128 44.2514 1.21117 44.1046 1.17447L43.132 0.862503L43.2788 0H45.7746V10.8639C45.7746 11.1208 45.7929 11.1575 46.0315 11.1942L47.0041 11.3043V12.1668H43.0586Z"
                                      fill="#9D9D9C"
                                    />
                                    <path
                                      d="M53.2626 5.79895C52.7855 5.39523 51.9046 4.93645 51.0605 4.93645C49.5373 4.93645 48.9501 6.25773 48.9501 8.1846C48.9501 10.4234 49.7025 11.1575 50.8403 11.1575C51.7945 11.1575 52.5653 10.5335 53.281 9.81785V5.79895H53.2626ZM53.5379 12.1668L53.4094 11.1024L53.336 11.0841C52.602 11.7998 51.7578 12.3503 50.4916 12.3503C48.6565 12.3503 47.4453 11.1575 47.4453 8.1846C47.4453 5.00986 48.8767 3.70693 50.8219 3.70693C51.7945 3.70693 52.657 4.03725 53.281 4.47767V1.48644C53.281 1.32128 53.2076 1.21117 53.0791 1.15612L52.1248 0.862503L52.2717 0H54.7307V10.8639C54.7307 11.1208 54.7491 11.1575 54.9876 11.1942L55.8134 11.3043V12.1668H53.5379Z"
                                      fill="#9D9D9C"
                                    />
                                    <path
                                      d="M59.1717 10.1116C59.7222 10.6438 60.5297 11.1576 61.3738 11.1576C62.9153 11.1576 63.4842 9.89136 63.4842 7.85438C63.4842 5.6706 62.6217 4.97326 61.6307 4.97326C60.6031 4.97326 59.6305 5.5972 59.1717 5.96422V10.1116ZM56.7861 15.5802V14.6994L57.4467 14.6076C57.6669 14.5709 57.722 14.5342 57.722 14.2773V5.37698C57.722 5.19347 57.6669 5.08337 57.5201 5.04666L56.6025 4.73469L56.7494 3.87219H58.8781L59.0249 4.8081L59.0799 4.82645C59.9608 4.16581 60.86 3.70703 61.9611 3.70703C63.7595 3.70703 64.989 4.86315 64.989 7.70758C64.989 10.1299 64.1632 12.3504 61.6307 12.3504C60.7132 12.3504 59.9424 12.1302 59.1717 11.4696V14.2589C59.1717 14.5158 59.19 14.5709 59.4286 14.5892L60.9518 14.7177V15.5802H56.7861Z"
                                      fill="#E30613"
                                    />
                                    <path
                                      d="M70.8797 8.45997L69.063 8.62513C67.6683 8.75359 67.2829 9.15731 67.2829 10.0015C67.2829 10.864 67.6499 11.231 68.4023 11.231C69.3566 11.231 70.3659 10.4602 70.8614 9.98311V8.45997H70.8797ZM71.155 12.1669L71.0082 11.1209L70.9531 11.1025C70.1824 11.8182 69.2832 12.3504 68.0353 12.3504C66.0167 12.3504 65.7598 10.9557 65.7598 10.1483C65.7598 8.53338 66.7507 7.78098 68.6959 7.61582L70.8797 7.43231V6.56981C70.8797 5.39533 70.6595 4.8081 69.2465 4.8081C68.2555 4.8081 67.5582 4.8448 67.5398 6.05597L66.1451 5.90917C66.1451 3.92724 67.9803 3.70703 69.2648 3.70703C71.5587 3.70703 72.3295 4.34932 72.3295 6.56981V10.8456C72.3295 11.1025 72.3478 11.1392 72.5864 11.1759L73.4122 11.286V12.1485H71.155V12.1669Z"
                                      fill="#E30613"
                                    />
                                    <path
                                      d="M74.3296 15.5802V14.6993L75.4857 14.5525C75.6876 14.5342 75.7427 14.4424 75.8344 14.2222L76.7703 12.0751L73.8708 5.21178C73.7974 5.00992 73.724 4.99157 73.5405 4.93652L72.8799 4.77136L73.0634 3.8905H76.4033V4.77136L75.3389 4.89981L77.486 10.3134L79.7248 4.89981L78.6238 4.77136L78.8073 3.8905H82.0004V4.77136L81.4499 4.84476C81.248 4.88146 81.1195 4.93652 81.0461 5.12003L77.1373 14.5525C77.1373 14.5525 76.9538 14.9929 76.8621 15.1764C76.7703 15.3967 76.5318 15.5802 76.2198 15.5802H74.3296Z"
                                      fill="#E30613"
                                    />
                                    <path
                                      d="M11.1096 11.5796C10.9995 11.7448 10.8711 11.9099 10.7243 12.0751C10.4123 12.4237 10.0453 12.7541 9.64154 13.0293C9.12771 13.378 8.59552 13.6533 8.04499 13.8551C7.56786 14.0203 7.14579 14.1121 6.77876 14.1304H6.65031C6.46679 14.1304 6.33834 14.1121 6.26493 14.057L6.22823 14.0386L6.19153 14.0019V13.9836C6.19153 13.9652 6.19153 13.9285 6.20988 13.8918C6.24658 13.8001 6.30163 13.7267 6.37504 13.6349C6.39339 13.6166 6.43009 13.5799 6.44844 13.5432C6.72371 13.4698 6.99898 13.378 7.31095 13.2863C7.58621 13.3413 7.87983 13.3597 8.13675 13.3413C8.46707 13.3046 8.77903 13.2128 9.0543 13.066C9.38462 12.8825 9.67824 12.644 9.9168 12.3503C10.0636 12.1485 10.1921 11.9466 10.2838 11.7081C10.7793 11.3227 11.2014 10.919 11.5317 10.5152L11.6969 10.295C11.5684 10.7354 11.3849 11.1759 11.1096 11.5796ZM9.21946 12.4054C9.32957 12.3503 9.42132 12.2769 9.53143 12.2219C9.38462 12.4054 9.20111 12.5706 9.0176 12.699C8.76068 12.8642 8.48542 12.9926 8.21015 13.0477C8.08169 13.066 7.97159 13.0844 7.84313 13.1027C8.30191 12.9009 8.77904 12.6623 9.21946 12.4054ZM12.5777 7.79927C12.5777 7.26708 12.4493 6.75325 12.1923 6.27612C11.9721 5.85405 11.6418 5.45032 11.2381 5.0833C11.1463 4.58782 10.8894 4.12904 10.504 3.70697C10.1921 3.37665 9.8067 3.08303 9.32957 2.82611C8.96255 2.62425 8.55882 2.45909 8.13675 2.33063C7.78807 2.22053 7.4394 2.16547 7.10908 2.12877C6.79711 2.09207 6.5402 2.11042 6.30163 2.14712C6.06307 2.20217 5.84286 2.27558 5.64099 2.38569L5.60429 2.40404C5.32902 2.36734 5.05376 2.36733 4.79684 2.38569H4.72344C4.46652 2.40404 3.93434 2.47744 3.97104 2.73436C3.97104 2.73436 3.97104 2.88117 4.30136 2.99127L4.76014 2.71601C4.72344 2.71601 4.68674 2.69766 4.65003 2.69766C4.79684 2.6793 4.94365 2.66095 5.05376 2.66095H5.14551C5.10881 2.6793 5.09046 2.69766 5.05376 2.71601L4.90695 2.80776C4.63168 2.97292 4.53993 3.04633 4.24631 3.21149C4.0628 3.32159 3.89764 3.4317 3.71413 3.52346C3.36545 3.70697 3.01678 3.89048 2.64976 4.07399C2.35614 4.20245 2.06252 4.34926 1.67715 4.51442L1.64045 4.53277C1.54869 4.56947 1.45694 4.60617 1.38353 4.64287H1.36518C1.27343 4.67958 1.16332 4.73463 1.10827 4.84474L1.08992 4.91814V4.99154C1.08992 5.0099 1.10827 5.02825 1.10827 5.02825L1.16332 5.0833L1.21837 5.12H1.23672C1.29178 5.13835 1.36518 5.13835 1.43859 5.13835H1.76891C1.89736 5.13835 2.02582 5.12 2.13593 5.12C2.74152 5.10165 3.29205 5.10165 3.82423 5.12C4.33806 5.13835 4.8519 5.19341 5.36573 5.24846L6.13647 5.35857C6.30163 5.21176 6.43009 5.10165 6.52185 4.99154C5.98966 4.88144 5.45748 4.80803 4.94365 4.75298C4.41147 4.69793 3.84258 4.66122 3.2737 4.66122H3.07184C2.79657 4.66122 2.50295 4.66122 2.22768 4.67958C2.50295 4.55112 2.74152 4.42266 2.98008 4.31255C3.32875 4.12904 3.67742 3.92718 4.02609 3.70697C4.28301 3.54181 4.55828 3.3583 4.87025 3.13808L4.9253 3.10138C5.29232 3.17478 5.73275 3.24819 6.17318 3.33994L7.10908 3.56016C6.98063 3.24819 6.59525 3.06468 6.37504 2.97292C6.06307 2.91787 5.73275 2.84446 5.34738 2.78941C5.43913 2.71601 5.53089 2.66095 5.62264 2.62425C5.93461 2.66095 6.19153 2.71601 6.43009 2.80776C6.6136 2.88117 6.76041 2.95457 6.88887 3.04633C6.90722 3.06468 6.94392 3.08303 6.96227 3.10138C7.18249 3.28489 7.31095 3.52346 7.31095 3.76202C7.3293 3.96388 7.27424 4.1841 7.16414 4.40431C7.10908 4.53277 7.01733 4.66122 6.92557 4.78968C6.90722 4.82639 6.74206 5.06495 6.37504 5.37692C6.02637 5.70724 5.60429 6.00086 5.09046 6.31283C4.90695 6.42293 4.74179 6.51469 4.55828 6.60644C4.33806 6.71655 4.11785 6.82666 3.93434 6.90006C3.64072 7.02852 3.14524 7.24873 2.5213 7.43224C2.19098 7.524 1.87901 7.61575 1.56704 7.67081C1.32848 7.72586 1.03486 7.76256 0.741244 7.78091C1.07156 7.63411 1.43859 7.54235 1.82396 7.4873C2.55801 7.32214 3.18194 7.08357 3.58567 6.90006C3.20029 6.90006 2.81492 6.91841 2.4112 6.95511C1.75056 7.02852 1.21837 7.12027 0.741244 7.28543C0.465977 7.37719 0.0989548 7.524 0.00719923 7.76256C-0.0111519 7.89102 0.00719923 7.98278 0.0439015 8.07453C0.117306 8.22134 0.264115 8.29475 0.50268 8.33145C0.686191 8.3498 0.888053 8.3498 1.16332 8.3131C1.6588 8.25804 2.19098 8.14794 2.79657 7.94607C3.32875 7.78091 3.80588 7.57905 4.26466 7.37719C4.77849 7.39554 5.29232 7.45059 5.7878 7.54235C6.31998 7.63411 6.77876 7.76256 7.21919 7.92772C7.71467 8.11124 8.13675 8.3131 8.48542 8.55166C8.61388 8.45991 8.72398 8.36815 8.81574 8.29475C8.79739 8.29475 8.79739 8.27639 8.77903 8.27639C8.33861 7.98278 7.82478 7.72586 7.27424 7.524C6.81546 7.35884 6.31998 7.23038 5.76945 7.12027C5.51254 7.06522 5.25562 7.02852 4.98035 7.01017C5.42078 6.7716 5.80615 6.53304 6.15482 6.25777C6.46679 6.01921 6.72371 5.78064 6.96227 5.54208C7.58621 5.70724 8.11839 5.8724 8.59552 6.07426C9.16441 6.31283 9.65989 6.58809 10.082 6.90006L10.1187 6.91841C10.2104 6.78995 10.2838 6.64315 10.3389 6.53304C9.95351 6.25777 9.53143 6.01921 9.07265 5.79899C8.55882 5.56043 7.98994 5.35857 7.366 5.19341C7.34765 5.19341 7.3293 5.17506 7.29259 5.17506C7.56786 4.78968 7.73302 4.42266 7.76972 4.07399C7.78807 3.96388 7.78807 3.87213 7.76972 3.76202C8.30191 3.92718 8.81574 4.12904 9.29287 4.34926C9.77 4.56947 10.1737 4.80803 10.5224 5.0833L10.5407 5.10165C10.449 4.71628 10.2471 4.42266 10.137 4.2942C9.91681 4.16574 9.67824 4.05564 9.42132 3.92718C8.9809 3.72532 8.48542 3.54181 7.95323 3.37665C7.84313 3.33994 7.71467 3.30324 7.60456 3.28489H7.58621C7.42105 2.99127 7.16414 2.82611 6.96227 2.71601C6.74206 2.6059 6.48515 2.51414 6.19153 2.45909C6.31998 2.44074 6.43009 2.42239 6.55855 2.42239H6.59525C6.70536 2.42239 6.83382 2.42239 6.96227 2.44074C6.99898 2.44074 7.01733 2.44074 7.05403 2.45909C7.366 2.49579 7.67797 2.5692 8.02664 2.6793C8.43036 2.80776 8.81574 2.97292 9.14606 3.17478C9.56813 3.41335 9.9168 3.68862 10.1921 4.00058C10.2838 4.11069 10.3756 4.2208 10.449 4.3309C10.4673 4.34926 10.4857 4.36761 10.4857 4.40431C10.4857 4.40431 10.4857 4.42266 10.504 4.42266C10.6325 4.64287 10.761 4.93649 10.7793 5.28516C10.816 5.65218 10.7426 6.01921 10.6325 6.31283C10.6325 6.33118 10.4857 6.7349 10.2288 7.10192C9.97186 7.4873 9.62319 7.87267 9.20111 8.23969C9.10935 8.33145 8.83409 8.57001 8.44872 8.82693C8.08169 9.08384 7.69632 9.32241 7.29259 9.54262C6.98063 9.72613 6.65031 9.87294 6.24658 10.0565C6.08142 10.1299 5.84286 10.2216 5.56759 10.3134C5.12716 10.4785 4.68674 10.607 4.24631 10.7171C3.60402 10.8639 3.03513 10.9557 2.4846 10.9924C2.26439 11.0107 2.06252 11.0107 1.86066 10.9924C1.56704 10.974 1.25508 10.9373 1.07156 10.7721L1.03486 10.7354V10.6987C1.07156 10.5886 1.16332 10.5152 1.25508 10.4418C1.38353 10.3501 1.53034 10.2767 1.71385 10.2033C2.13593 10.0381 2.61306 9.928 3.16359 9.87294C3.67742 9.83624 4.20961 9.85459 4.70509 9.928C4.962 9.9647 5.21892 10.0381 5.47583 10.1115C5.65934 10.0565 5.84286 9.98305 5.97131 9.928C5.65934 9.79954 5.31067 9.68943 4.94365 9.59768C4.42982 9.48757 3.87929 9.45087 3.32875 9.46922C2.75987 9.48757 2.22768 9.57932 1.75056 9.72613C1.36518 9.85459 0.943106 10.0198 0.686191 10.3501C0.576084 10.4969 0.521031 10.662 0.557733 10.8456C0.594435 11.0658 0.777946 11.2126 0.869702 11.2676C1.10827 11.4144 1.40188 11.4878 1.60375 11.5062C1.82396 11.5429 2.06252 11.5612 2.31944 11.5612H2.4479C2.98008 11.5429 3.54897 11.4695 4.22796 11.3227C4.79684 11.1942 5.38408 11.0291 5.98966 10.7905C6.15482 10.7171 6.33834 10.662 6.5035 10.5886C6.77876 10.7721 6.98063 10.974 7.10908 11.1942C7.23754 11.4144 7.29259 11.6163 7.29259 11.8365C7.29259 12.0384 7.23754 12.2402 7.12743 12.4237C7.10908 12.4788 7.07238 12.5155 7.03568 12.5706C7.16414 12.5339 7.29259 12.4788 7.42105 12.4237L7.47611 12.3136C7.56786 12.0751 7.60456 11.8182 7.56786 11.5796C7.53116 11.3043 7.4027 11.0291 7.20084 10.7905C7.10908 10.662 6.98063 10.5519 6.85217 10.4418C7.4394 10.1666 7.97159 9.87294 8.44872 9.56097C8.68728 9.39581 8.92584 9.23065 9.14606 9.06549C9.51308 9.41417 9.78835 9.79954 9.9168 10.2216C9.99021 10.4418 10.0269 10.662 10.0269 10.9006C10.1737 10.7721 10.3022 10.662 10.3939 10.5703C10.3572 10.24 10.2471 9.928 10.0636 9.61603C9.9168 9.34076 9.69659 9.08384 9.43968 8.82693C9.93516 8.40485 10.3389 7.96443 10.6325 7.50565C10.6508 7.4873 10.6692 7.45059 10.6876 7.43224C11.0546 7.79927 11.3298 8.20299 11.5134 8.60672V8.62507C11.5501 8.69847 11.5684 8.79023 11.6051 8.86363C11.7336 8.57001 11.7886 8.3131 11.807 8.14794C11.6602 7.85432 11.4583 7.57905 11.2381 7.34049C11.1463 7.23038 11.0362 7.13863 10.9261 7.02852C11.128 6.60644 11.2564 6.20272 11.2931 5.81735C11.3849 5.92745 11.4767 6.03756 11.5501 6.14767C11.8253 6.56974 12.0088 7.01017 12.0455 7.43224C12.0639 7.5974 12.0639 7.74421 12.0639 7.90937C12.0639 7.92772 12.0639 8.09288 12.0088 8.3498C12.0088 8.3865 11.9905 8.44156 11.9721 8.47826C11.9171 8.68012 11.8253 8.93704 11.6969 9.2123C11.6785 9.23065 11.6785 9.26736 11.6602 9.28571C11.6418 9.30406 11.6418 9.34076 11.6235 9.35911C11.3849 9.79954 11.0546 10.24 10.6325 10.6437C10.5774 10.6987 10.5224 10.7538 10.449 10.8089C10.3022 10.9557 10.082 11.1392 9.8801 11.286C9.47638 11.5979 9.03595 11.8732 8.57717 12.1118C8.2285 12.2953 7.86148 12.4788 7.47611 12.6256C7.07238 12.7908 6.68701 12.9192 6.39339 12.9926C5.84286 13.1394 5.31067 13.2495 4.79684 13.3046C4.31971 13.3413 3.95269 13.3413 3.60402 13.2863C3.38381 13.2495 3.21865 13.1945 3.07184 13.1211C3.03513 13.1027 2.99843 13.066 2.98008 13.0477C2.98008 13.0293 2.96173 13.0293 2.96173 13.011V12.9743C3.03513 12.7908 3.2737 12.699 3.51226 12.6256C3.73248 12.5522 4.00774 12.5155 4.30136 12.5155H4.33806C4.61333 12.5155 4.8886 12.5522 5.18222 12.6256C5.45748 12.6807 5.73275 12.7724 5.97131 12.8642C5.98966 12.8642 5.98967 12.8825 6.00802 12.8825C6.11812 12.8642 6.24658 12.8275 6.41174 12.7724C6.39339 12.7724 6.37504 12.7541 6.33834 12.7541C6.22823 12.7174 6.11812 12.6623 6.00802 12.6256C5.69605 12.4972 5.43913 12.4237 5.18222 12.3503C4.87025 12.2769 4.55828 12.2219 4.26466 12.2219C3.95269 12.2035 3.64072 12.2402 3.3471 12.3136C3.03513 12.387 2.81492 12.5155 2.64976 12.6623C2.53965 12.7724 2.4846 12.9192 2.4846 13.066C2.4846 13.2128 2.55801 13.3597 2.68646 13.4698C3.01678 13.7634 3.54897 13.8368 3.97104 13.8551C4.50322 13.8918 5.07211 13.8368 5.69605 13.7267C5.76945 13.7083 5.86121 13.69 5.93461 13.6716C5.87956 13.7634 5.8245 13.8551 5.80615 13.9652C5.7878 14.1304 5.87956 14.2956 6.06307 14.3873C6.22823 14.4791 6.44844 14.5341 6.74206 14.5341H6.90722C7.366 14.5158 7.84313 14.4057 8.37531 14.2038C8.90749 14.0203 9.40297 13.745 9.8801 13.4331C10.3022 13.1394 10.7059 12.7908 11.0362 12.4054C11.3849 12.0017 11.6785 11.5612 11.862 11.1025C12.0639 10.6437 12.1556 10.1299 12.1373 9.63438C12.1373 9.56097 12.1373 9.48757 12.1189 9.41416C12.4493 8.88198 12.5777 8.33145 12.5777 7.79927Z"
                                      fill="#E30613"
                                    />
                                  </svg>
                                </span>
                                <span v-else>
                                  {{ gateway.name }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </dd>
                      </div>
                    </div>
                    <div
                      class="mt-8 sm:mt-0 sm:grid sm:grid-cols-2 sm:border-gray-200 sm:pt-5"
                    >
                      <dt class="text-sm leading-5 font-normal">
                        {{ $t("enter-amount") }}
                      </dt>
                      <dd
                        class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-1"
                      >
                        <div class="sm:col-span-1">
                          <ValidationProvider
                            v-slot="{ errors }"
                            :name="
                              $t(
                                'the-minimum-amount-that-can-be-withdrawn-is-1'
                              )
                            "
                            :rules="`required|min_value:1|max_value:${get_payments_info.withdrawable_balance}`"
                          >
                            <div
                              class="mt-1 relative rounded-md shadow-sm input"
                            >
                              <div
                                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                              >
                                <span
                                  class="text-gray-300 sm:text-md sm:leading-5"
                                >
                                  {{
                                    new Intl.NumberFormat("en-US", {
                                      style: "currency",
                                      currency: get_profile.profile.currency,
                                    })
                                      .format()
                                      .slice(0, -3)
                                  }}
                                </span>
                              </div>
                              <input
                                id="amount1"
                                v-model="form.amount"
                                aria-describedby="price-currency"
                                class="form-input h-12 font-light block w-full pl-7 pr-3 sm:text-sm sm:leading-5"
                                step="any"
                                type="number"
                              />
                            </div>
                            <span class="text-sm text-red-600 h-4">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                      </dd>
                    </div>
                  </div>
                  <Button
                    class="relative mt-12 block w-full bg-main-button-color items-center px-4 py-2 border border-transparent text-sm leading-5 font-normal rounded-md text-white focus:outline-none focus:shadow-outline-indigo"
                    type="submit"
                  >
                    {{ $t("request-a-payment") }}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <ib-approval-alert v-if="get_ib_profile.state === 'Pending'" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import MoneyFormat from "vue-money-format";
import Header from "@/components/Header";
import IbApprovalAlert from "@/components/IbApprovalAlert";

export default {
  name: "RequestPayment",
  components: {
    "money-format": MoneyFormat,
    Header,
    IbApprovalAlert,
  },
  data() {
    return {
      whitelabel: process.env.VUE_APP_WHITELABEL,
      inputNumberVisible: true,
      inputNumberError: "",
      dotValue: 0,
      form: {
        amount: "",
        selectedMethod: {},
        selectedGateway: {},
      },
    };
  },
  computed: {
    ...mapGetters([
      "get_payments_info",
      "get_ib_withdrawal_methods",
      "get_profile",
      "get_ib_profile",
    ]),
  },
  created() {
    this.$store.dispatch("set_payments_info");
    if (
      this.whitelabel !== "TD365" &&
      this.whitelabel !== "TDSouthAfrica" &&
      this.whitelabel !== "Blackstone" &&
      this.whitelabel !== "OneTradingMarkets" &&
      this.whitelabel !== "EagleGlobalMarkets" &&
      this.whitelabel !== "TradeCoreUK"
    ) {
      this.$store.dispatch("set_ib_withdrawals_methods").then((resp) => {
        this.form.selectedMethod = resp.data[0];
        this.form.selectedGateway = this.form.selectedMethod.gateways[0];
      });
    }
  },
  methods: {
    sanitizeText(text) {
      return this.$sanitize(text);
    },
    updateSelectedGateway() {
      this.form.selectedGateway = this.form.selectedMethod.gateways[0];
    },
    setGateway(gateway) {
      this.form.selectedGateway = gateway;
    },
    requestPayment() {
      const data = {
        amount: this.form.amount,
      };
      if (
        this.whitelabel !== "TD365" &&
        this.whitelabel !== "TDSouthAfrica" &&
        this.whitelabel !== "Blackstone" &&
        this.whitelabel !== "OneTradingMarkets" &&
        this.whitelabel !== "EagleGlobalMarkets" &&
        this.whitelabel !== "TradeCoreUK"
      ) {
        data.gateway = this.form.selectedGateway.id;
        data.method = this.form.selectedMethod.value;
      }
      this.$store
        .dispatch("post_withdraw_request", data)
        .then(() => {
          this.$store.dispatch("set_payments_info");
          this.$notify({
            group: "foo",
            text: `${this.$t(
              "your-payment-request-has-been-received-and-is-pending-approval"
            )}`,
          });
        })
        .catch((err) => {
          this.$notify({
            group: "foo",
            text: `${err.data.messages[0].text}`,
            type: "warn",
          });
        });
    },
  },
};
</script>
